<template>
  <b-modal
    size="xl"
    id="modal-question"
    :title="editItem ? 'Edit vérification' : 'Ajout vérification'"
    hide-footer
    class="m-0"
  >
    <b-form @submit.prevent="onSubmit">
      <b-row class="mb-1">
        <b-col sm="6" class="pl-0">
          <div>
            <h5 class="mb-3 text-center">Composants</h5>

            <b-form-select
              v-model="form.components"
              :options="components"
              :select-size="components.length + 13"
              multiple
              required
            ></b-form-select>
          </div>
        </b-col>

        <b-col sm="6">
          <!-- Type -->
          <b-card
            class="mb-2"
            header-class=" text-center font_bold"
            border-variant="info"
            header="Types"
          >
            <b-row>
              <b-col sm="6">
                <b-form-group label="Statique" v-slot="{ ariaDescribedby }">
                  <b-form-radio
                    v-model="form.static"
                    :aria-describedby="ariaDescribedby"
                    name="form-static"
                    value="true"
                    >Oui</b-form-radio
                  >
                  <b-form-radio
                    v-model="form.static"
                    :aria-describedby="ariaDescribedby"
                    name="form-static"
                    value="false"
                    >Non</b-form-radio
                  >
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Dynamique" v-slot="{ ariaDescribedby }">
                  <b-form-radio
                    v-model="form.dynamic"
                    :aria-describedby="ariaDescribedby"
                    name="form-dynamic"
                    value="true"
                    >Oui</b-form-radio
                  >
                  <b-form-radio
                    v-model="form.dynamic"
                    :aria-describedby="ariaDescribedby"
                    name="form-dynamic"
                    value="false"
                    >Non</b-form-radio
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <!-- Ordre affichage -->
          <b-card
            class="mb-2"
            header-class=" text-center font_bold"
            border-variant="info"
            header="Ordre affichage"
          >
            <b-row>
              <b-col sm="6">
                <b-form-group>
                  <b-form-radio
                    v-model="form.properties.displayOrder"
                    name="form-displayOrder"
                    value="normal"
                    >Normal</b-form-radio
                  >
                  <b-form-radio
                    v-model="form.properties.displayOrder"
                    name="form-displayOrder"
                    value="first"
                    >En premier</b-form-radio
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="N° ordre" label-for="nested-order">
                  <b-form-input
                    v-model="form.properties.orderNumber"
                    id="nested-order"
                    autocomplete="off"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <!-- Question form -->
          <b-card bg-variant="light">
            <b-form-group
              label="Intitulé vérification"
              label-for="nested-question"
              label-size="lg"
            >
              <b-form-textarea
                required
                v-model="form.question"
                id="nested-question"
              ></b-form-textarea>
            </b-form-group>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  label="Catégorie vérification"
                  label-for="nested-category"
                >
                  <b-form-select v-model="form.cat" >
                    <b-form-select-option
                      v-for="cat in categories"
                      :key="cat.id"
                      :value="cat">
                      {{ cat.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group label="Priorité" label-for="nested-priority">
                  <b-form-input
                    v-model="form.priority"
                    id="nested-priority"
                    autocomplete="off"
                    disabled
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Aide" label-for="nested-help">
                  <b-form-textarea
                    rows="8"
                    v-model="form.help"
                    id="nested-help"
                  ></b-form-textarea>
                </b-form-group>

                <b-form-group label="Documents" label-for="nested-images">
                  <b-form-file
                    id="file"
                    ref="file"
                    multiple
                    placeholder="Sélectionnez ou glisser un fichier ici"
                    drop-placeholder="Glissez le fichier ici..."
                    browse-text="Parcourir"
                  ></b-form-file>
                </b-form-group>
                <b-button
                  size="sm"
                  v-if="showDocButton"
                  v-b-modal.modal-1
                  variant="secondary"
                  @click="getImages()"
                >
                  {{ form.properties.images.length }} Documents
                </b-button>

                <b-form-group label="Temps" label-for="nested-time">
                  <b-form-select
                    v-model="form.time"
                    :options="['Fort', 'Moyen', 'Faible', 'Variable']"
                    required
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Matériel" label-for="nested-equipment">
                  <b-form-select
                    v-model="form.equipment"
                    multiple
                    :select-size="23"
                    :options="equipment"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Unités possibles">
                  <b-form-select
                    v-model="form.possibleUnits"
                    :options="possibleUnits"
                    :select-size="possibleUnits.length"
                    multiple
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Source (interne)" class="mt-5">
                  <b-form-textarea
                    rows="6"
                    v-model="form.properties.source"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group label="Commentaire (interne)" class="mt-5">
                  <b-form-textarea
                    rows="6"
                    v-model="form.comment"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <!-- Réponses et traitement -->
        <b-col sm="12" class="mt-5 border-top">
          <h4 class="mb-3 mt-3 text-center">Réponses</h4>

          <b-col sm="12">
            <b-row>
              <b-col>
                <b-form-group label="Type réponse" class="border-bottom pb-2">
                  <b-form-radio-group
                    v-model="form.answerType"
                    :options="[
                      { text: 'Choix multiple', value: 'multipleChoice' },
                      { text: 'Libre', value: 'free' },
                      { text: 'Libre (type: nombre)', value: 'freeNumber' },
                    ]"
                    button-variant="outline-secondary"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>

                <!-- ANSWERS -->
                <div v-if="form.answerType !== 'free' && form.answerType !== 'freeNumber'">
                  <b-card
                    v-for="(answer, index) in form.answers"
                    :key="index"
                    class="border-bottom mt-2 mb-5"
                    bg-variant="light"
                    header-bg-variant="info"
                    :header="String(index + 1)"
                    header-class="cardHeader"
                  >
                    <b-row>
                                  <b-col
                        cols="4"
                        v-if="
                          form.answerType === 'multipleChoice'
                        "
                      >
                        <b-form-group
                          :label="'Si valeur saisie = '"
                          :label-cols="'5'"
                        >
                          <b-form-textarea
                            v-if="form.answerType === 'multipleChoice'"
                            v-model="answer.valueAnswer"
                            required
                          ></b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row class="mt-3 pt-5 border-top">
                      <b-col cols="2">
                        <b-form-checkbox
                          v-model="answer.isDefault"
                          @change="isDefaultChange(index, answer.isDefault)"
                          :value="false"
                          :unchecked-value="false"
                        >
                          Pas de défaut
                        </b-form-checkbox>
                        <b-form-checkbox
                          v-model="answer.isDefault"
                          @change="isDefaultChange(index, answer.isDefault)"
                          :value="true"
                          :unchecked-value="false"
                        >
                          Défaut
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="8">
                        <b-form-group
                          :label="
                            answer.isDefault
                              ? 'Explication (optionnelle)'
                              : 'Nature défaut'
                          "
                          label-for="nested-then"
                          label-cols-sm="3"
                          content-cols-sm="9"
                          label-align-sm="right"
                          class="pb-5 border-bottom"
                        >
                          <b-form-textarea
                            v-model="answer.then"
                            :required="!answer.isDefault"
                          ></b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6">
                        <b-form-group
                          label="Correction"
                          label-for="sort-by-select"
                          class="mb-3"
                          v-if="answer.isDefault"
                        >
                          <b-form-textarea
                            v-model="answer.correction"
                          ></b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="text-right">
                      <b-button
                        v-if="
                          answer === form.answers[form.answers.length - 1] &&
                            index !== 0
                        "
                        @click="removeAnswer"
                        class="mt-5 mb-5 mr-5"
                        variant="outline-secondary"
                      >
                        <h4>-</h4>
                      </b-button>
                      <b-button
                        v-if="answer === form.answers[form.answers.length - 1]"
                        @click="addAnswer"
                        class="mt-5 mb-5 w_250"
                        variant="secondary"
                        :disabled="
                          (!answer.isDefault && answer.then === '') ||
                            answer.operator === '' ||
                            answer.valueAnswer === ''
                        "
                      >
                        <b-icon icon="plus" font-scale="2"></b-icon>
                      </b-button>
                    </div>
                  </b-card>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
      <b-col offset-sm="2" sm="8">
        <b-row>
          <b-col>
            <b-card :bg-variant="form.active ? 'success' : 'warning'">
              <b-form-group
                label="Publié"
                label-for="formActive"
                label-cols-sm="2"
                label-align-sm="right"
                content-cols-sm="8"
                class="mb-0"
              >
                <b-form-select
                  v-model="form.active"
                  id="formActive"
                  :options="[
                    { text: 'Oui', value: true },
                    { text: 'Non', value: false },
                  ]"
                ></b-form-select>
              </b-form-group>
            </b-card>
          </b-col>
          <b-col>
            <b-card :bg-variant="form.validate ? 'success' : 'warning'">
              <b-form-group
                label="Validé"
                label-for="formActive"
                label-cols-sm="2"
                label-align-sm="right"
                content-cols-sm="8"
                class="mb-0"
              >
                <b-form-select
                  v-model="form.validate"
                  id="formValidate"
                  :options="[
                    { text: 'Oui', value: true },
                    { text: 'Non', value: false },
                  ]"
                ></b-form-select>
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-alert variant="success" :show="success"
        >Vérification {{ editItem ? "modifiée" : "créée" }}</b-alert
      >
      <b-button
        block
        class="mt-3 mb-3"
        type="submit"
        variant="primary"
        :disabled="success"
        ><span class="font-weight-bold fs_15">{{
          editItem ? "Modifier" : "Ajouter nouvelle vérification"
        }}</span>
        <b-spinner small class="ml-3" v-if="isLoading"></b-spinner>
      </b-button>
    </b-form>

    <!-- MODAL DOCUMENTS -->
    <b-modal
      id="modal-1"
      scrollable
      title="Documents"
      size="lg"
      cancel-title="Annuler"
    >
      <div v-if="!isFullscreen">
        <b-row>
          <b-col cols="6" v-for="image in imageUrl" :key="image.name">
            <img :src="image.src" width="200" fluid alt="Responsive image" />
            <b-button variant="danger" @click="deleteFile(image, 'image')"
              >Supprimer</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" v-for="pdf in pdfUrl" :key="pdf.name">
            <div>
              <div @click="openFile(pdf.src)">
                <pdf :src="pdf.src"></pdf>
              </div>
              <b-button variant="danger" @click="deleteFile(pdf, 'pdf')"
                >Supprimer</b-button
              >
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="isFullscreen">
        <pdf
          :src="sourceFile"
          v-for="i in numPages"
          :key="i"
          :page="i"
          style="height: 100%"
        ></pdf>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
// import VGrid from "@revolist/vue-datagrid";
require("json-circular-stringify");
import imageCompression from "browser-image-compression";
import pdf from "vue-pdf";

export default {
  name: "ModalVerification",
  props: {
    editItem: Object,
    duplicItem: Object,
  },
  data() {
    return {
      cloneItem: {},
      pageCount: 0,
      numPages: undefined,
      form: {
        cat: {},
        categoryId: null,
        usages: [],
        // buildings: [],
        components: [],
        documentaryAnalysis: false,
        visualCheck: true,
        measure: true,
        question: "",
        equipment: [],
        step: [],
        possibleUnits: [],
        help: "",
        criteria: "",
        time: "Faible",
        answerType: "free",
        function: "",
        comment: "",
        properties: {},
        lastModification: "",
        active: false,
        validate: false,
        priority: 0,
        // weight: 0,
        answers: [
          {
            valueAnswer: "",
            // toleranceCoefficient: "0",
            isDefault: false,
            correction: "",
            // frequency: "Aucune",
            then: "",
          },
        ],
      },
      // buildings: [],
      // usages: [],
      filteredUsages: [],
      // technologies: [],
      components: [],
      tempSelectedComponent: [],
      filterComponents: [],
      // locations: [],
      success: false,
      isLoading: false,
      operators: ["=", "<=", "<", ">=", ">"],
      show: false,
      equipment: [
        "Mètre ruban",
        "Pied à coulisse",
        "Boussole (ou appli)",
        "Clinomètre (ou appli)",
        "Thermomètre de contact",
        "Thermomètre infrarouge",
        "Hygromètre",
        "Débitmètre à pression différentielle",
        "Débitmètre à ultrasons",
        "Réfractomètre",
        "Mesureur pH",
        "Manomètre",
        "Manomètre pour robinet",
        "Verre doseur",
        "Cône de mesure",
        "Anémomètre thermique (fil chaud)",
        "Anémomètre thermique (quadrillage)",
        "Anémomètre à hélice",
        "Sonde Pitot",
        "Analyseur de combustion",
        "Déprimomètre",
        "Lampe",
        "Luxmètre",
      ],
      // parts: [],
      // partsAndSpecificities: [],
      // specificities: [],
      // selectedSpecificities: [],
      possibleUnits: [
        "",
        "mm",
        "cm",
        "m",
        "°",
        "l",
        "m3",
        "°C",
        "K",
        "%",
        "bar",
        "Pa",
        "hPa",
        "kPa",
        "mmCE",
        "mCE",
        "kWh",
        "MWh",
        "W",
        "kW",
        "W/m²",
        "W/m²/K",
        "lux",
        "lm",
        "lm/W",
        "l/min",
        "l/h",
        "m3/s",
        "m3/h",
        "kg/h",
        "m/s",
        "min",
        "h",
      ],
      units: [
        "",
        "mm",
        "cm",
        "m",
        "°",
        "l",
        "m3",
        "°C",
        "K",
        "%",
        "bar",
        "Pa",
        "hPa",
        "kPa",
        "mmCE",
        "mCE",
        "kWh",
        "MWh",
        "W",
        "kW",
        "W/m²",
        "W/m²/K",
        "lux",
        "lm",
        "l/min",
        "l/h",
        "m3/s",
        "m3/h",
        "kg/h",
        "m/s",
      ],

      correction: "",
      // frequency: ["Aucune", "Faible", "Moyen", "Fort", "Variable"],
      testResult: "",
      userAnswerMax: 200,
      userAnswerBeginValue: 1,
      userAnswerInterval: 1,
      userAnswerTest: 0,
      priorityArray: [],
      // weightArray: [],
      imageUrl: [],
      pdfUrl: [],
      isFullscreen: false,
      sourceFile: "",
      showDocButton: false,
      categories: [],
    };
  },
  components: {
    pdf,
  },
  created() {
    // console.log(this.editItem);
    if (this.editItem) {
      this.getImages();
      this.cloneItem = { ...this.editItem };
    }
    if (this.duplicItem) {
      this.cloneItem = { ...this.duplicItem };
      delete this.cloneItem.id;
      delete this.cloneItem.createdAt;
    }
    this.getAll();
  },
  mounted() {
    console.log("mounted");
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      // console.log('Modal is about to be shown', bvEvent, modalId)
      if (modalId === "modal-1") {
        this.isFullscreen = false;
      }
    });
  },
  methods: {
    getAll() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getAll", {
        method: "POST",
        // body: JSON.stringify({
        // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {
   
          this.components = json.component.map((item) => {
            item.value = item;
            item.text = item.name;
            return { ...item };
          });
          this.categories = json.category;
          

          this.components.sort((a, b) => a.name.localeCompare(b.name));

          // IF EDIT or duplicate
          if (this.editItem || this.duplicItem) {
            this.form = { ...this.cloneItem };
            if (!this.form.installationCharacteristic) {
              this.form.installationCharacteristic = {};
            }
            let selecSys = this.components.filter((item) => {
              return this.cloneItem.componentIds.includes(item.id);
            });
            // Pour que form.components soit reactif
            this.$set(this.form, "components", selecSys);

            console.log(this.form);
            this.$set(this.form, "cat", this.form.cat);

            if (
              this.form.properties.images &&
              this.form.properties.images.length > 0
            ) {
              this.showDocButton = true;
            }

            this.calculateWeightAndPriority();
          }
          if (!this.form.properties.displayOrder) {
            this.form.properties.displayOrder = "normal";
          }

          if (!this.form.answers) {
            this.form.answers = [
              {
                valueAnswer: "",
                toleranceCoefficient: "0",
                isDefault: false,
                operator: "=",
                unit: "mm",
                shortTermImpact: "Aucun",
                longTermImpact: "Aucun",
                natureOfImpact: ["Surconsommation d'énergie"],
                correction: "",
                frequency: "Aucune",
                then: "",
              },
            ];
          }
        });
    },
    getImages() {
      this.pdfUrl = [];
      this.imageUrl = [];
      // console.log(this.form.properties.images);
      if (
        this.form?.properties?.images &&
        this.form.properties.images.length > 0
      ) {
        for (const image of this.form.properties.images) {
          fetch(
            `${
              process.env.VUE_APP_API_BASE_URL
            }/api/v1/component/download?docData=${JSON.stringify(image)}`,
            {
              method: "GET",
              // body: JSON.stringify({
              //   // componentId: 1,
              // }),
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.localStorage.token}`
              },
            }
          )
            .then(async (res) => res.blob())
            .then((blob) => {
              // console.log(blob);
              if (blob.type.includes("image")) {
                this.imageUrl.push({
                  name: image.name,
                  src: window.URL.createObjectURL(new Blob([blob])),
                });
              }
              if (blob.type.includes("pdf")) {
                this.pdfUrl.push({
                  name: image.name,
                  src: window.URL.createObjectURL(new Blob([blob])),
                });
              }

              console.log(this.pdfUrl);

              // }
            });
        }
      }
    },
    deleteFile(file, type) {
      if (type === "pdf") {
        this.pdfUrl = this.pdfUrl.filter((item) => item.name !== file.name);
      }
      if (type === "image") {
        this.imageUrl = this.imageUrl.filter((item) => item.name !== file.name);
      }

      this.form.properties.images = this.form.properties.images.filter(
        (item) => item.name !== file.name
      );
      //       this.getImages()
      // console.log(this.form.properties.images);
    },
    onSubmit() {
      console.log(this.form);
      this.isLoading = true;

      if (!this.form.properties.images) {
        this.form.properties.images = [];
      }

      if (this.$refs.file.files.length > 0) {
        console.log("il y a des fichiers");
        for (const file of this.$refs.file.files) {
          this.form.properties.images.push({
            name: file.lastModified,
            type: file.type,
          });
        }
      }

      this.form.lastModification = JSON.parse(localStorage.user).email.split('@')[0];

      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/component/" +
          (this.editItem ? "updateQuestion" : "saveQuestion"),
        {
          method: "POST",
          body: JSON.stringify(this.form),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then(async () => {
          await this.uploadFiles();
          this.isLoading = false;

          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 6000);
        })
        .catch((error) => {
          this.errorMessage = error;
          console.error("There was an error!", error);
          this.isLoading = false;
        });
    },
    getTechnologyByUsage(usageId) {
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/component/getTechnologyByUsage",
        {
          method: "POST",
          body: JSON.stringify({
            usageId: usageId,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          this.technologies = json.map((item) => {
            item.value = item;
            item.text = item.name;
            return { ...item };
          });
          this.technology = this.technologies[0];
        });
    },
    getComponentByTechnology(technologyId) {
      // console.log(technologyId);
      // console.log(this.components);

      this.filterComponents = this.components
        .map((item) => {
          if (item.technologyId === technologyId) {
            item.value = item;
            item.text = item.name;
            return { ...item };
          }
        })
        .filter((item) => item);

    },
    selectedTechnology(technology) {
      this.getComponentByTechnology(technology.id);
    },
    addAnswer() {
      this.form.answers.push({
        operator: this.operators[
          this.operators.findIndex(
            (item) =>
              item === this.form.answers[this.form.answers.length - 1].operator
          ) + 1
        ],
        valueAnswer: "",
        toleranceCoefficient: "0",
        isDefault: false,
        unit: "mm",
        shortTermImpact: "Aucun",
        longTermImpact: "Aucun",
        natureOfImpact: ["Aucun"],
        correction: "",
        frequency: "Aucune",
        then: "",
      });
      //          return this.operators.filter((item)=>this.form.answers.find((op)=>op.operator === item) ? '' : item);
    },
    removeAnswer() {
      this.form.answers.pop();
      //          return this.operators.filter((item)=>this.form.answers.find((op)=>op.operator === item) ? '' : item);
    },
    selectedComponents(components) {
      console.log(components);

      this.form.components = [...components];
    },
    toleranceChange() {
      console.log(this.form.toleranceCoefficient);
      console.log(this.form.toleranceCoefficient);
    },
    changeTypo() {
      console.log(this.form.buildings);
    },
    onAutoRefChange() {
      // console.log(this.form.installationCharacteristic);
      if (this.form.autoReference) {
        (this.form.autoreferenceValue = "installationCharacteristic"),
          (this.form.answerType = "");
        this.form.answers = [
          {
            valueAnswer: "",
            toleranceCoefficient: "0",
            operator: "=",
            unit: "mm",
            shortTermImpact: "Aucun",
            longTermImpact: "Aucun",
            natureOfImpact: ["Surconsommation d'énergie"],
            correction: "",
            frequency: "Aucune",
            then: "",
          },
        ];
      } else {
        this.form.installationCharacteristic = {};
        this.form.autoreferenceValue = "";
      }
    },
    onAutoRefValueChange() {
      console.log(this.form.autoreferenceValue);
      // if (this.form.autoreferenceValue === "documentaryValue") {
      //   this.form.installationCharacteristic = {};
      // }
    },
    sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
    charChange() {
      console.log(this.form.installationCharacteristic);
      if (this.form.installationCharacteristic.name === "plusieursBallons") {
        this.form.answerType = "multipleChoice";
      }
    },
    priorityCalculation() {
      this.priorityArray = [];

      let impact = 0;
      let frequency = 0;

      for (const item of this.form.answers) {
        let maxImpact = [];

        console.log(item);
        switch (item.longTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        switch (item.shortTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        switch (item.frequency) {
          case "Faible":
            frequency = 1;
            break;
          case "Moyen":
            frequency = 2;
            break;
          case "Fort":
            frequency = 4;
            break;
          case "Variable":
            frequency = 2;
            break;
          case "Aucune":
            frequency = 0;
            break;
        }
        impact = Math.max(...maxImpact);
        this.priorityArray.push(impact * frequency);
      }
      this.form.priority = Math.max(...this.priorityArray);

      this.form.properties.priority2 = this.priorityArray.reduce(
        (acc, curr) => acc + curr,
        0
      );
      // console.log(this.form.properties.priority2);
    },
    weightCalculation() {
      // console.log(this.form.priority);
      this.weightArray = [];

      let impact = 0;

      for (const item of this.form.answers) {
        let maxImpact = [];
        switch (item.longTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        switch (item.shortTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        impact = Math.max(...maxImpact);
        this.weightArray.push(impact);
      }
      this.form.properties.weight = Math.max(...this.weightArray);
    },
    calculateWeightAndPriority() {
      this.weightCalculation();
      this.priorityCalculation();
    },
    uploadFiles() {
      // console.log(this.$refs.file.files);
      const options = {
        // maxSizeMB: 1, // number(default: Number.POSITIVE_INFINITY)
        // maxWidthOrHeight, // number compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
        // but, automatically reduce the size to smaller than the maximum Canvas size supported by each browser.
        // Please check the Caveat part for details.
        // onProgress: Function, // optional, a function takes one progress argument (percentage from 0 to 100)
        // useWebWorker: boolean, // optional, use multi-thread web worker, fallback to run in main-thread (default: true)

        // following options are for advanced users
        // maxIteration: number, // optional, max number of iteration to compress the image (default: 10)
        // exifOrientation: number, // optional, see https://stackoverflow.com/a/32490603/10395024
        // fileType: string, // optional, fileType override
        initialQuality: 0.2, // optional, initial quality value between 0 and 1 (default: 1)
      };
      var files = this.$refs.file.files;
      var promises = files.map(async (file) => {
        // console.log(file);
        if (file.type.includes("image")) {
          file = await imageCompression(file, options);
          // console.log(file.size);
        }

        // const imgName = file.name;
        const formData = new FormData();
        formData.append(file.lastModified, file);

        // formData.append(imgName.split(".")[0], file);
        // formData.set('questionId', questionId);

        return new Promise((resolve) => {
          fetch(
            process.env.VUE_APP_API_BASE_URL +
              "/api/v1/component/uploadFromComponent",
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${this.localStorage.token}`
              },
              body: formData,
            }
          ).then(() => resolve());
        });
      });
      return Promise.all(promises);
    },
    isDefaultChange(index, isNotDefault) {
      if (isNotDefault) {
        this.form.answers[index].natureOfImpact = ["Aucun"];
        this.form.answers[index].shortTermImpact = "Aucun";
        this.form.answers[index].longTermImpact = "Aucun";
        this.form.answers[index].natureOfImpact = ["Aucun"];
        this.form.answers[index].correction = "";
        this.form.answers[index].frequency = "Aucune";
      }
    },
    openFile(file) {
      this.isFullscreen = true;
      let loadingTask = pdf.createLoadingTask(file);
      loadingTask.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
      this.sourceFile = file;
    },
    selectLocal(ev) {
      console.log(ev);
    },
    changeCat(cat) {
      this.form.cat = this.categories.find((item) => item.id === cat);
    },
  },
  watch: {},
  // computed: {
  //   operatorsComp() {
  //          return this.operators.filter((item)=>this.form.answers.find((op)=>op.operator === item) ? '' : item);
  //   }
  // }
};
</script>
<style>
.modal-xl {
  max-width: 95% !important;
}
.w_250 {
  width: 40%;
}

.cardHeader {
  text-align: right;
  color: #ffffff;
  font-size: 1.2em;
  font-weight: bold;
}

.font_bold {
  font-weight: bold;
}

.fs_15 {
  font-size: 1.4em;
}
</style>
